import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { apiGet, TENANT_TOKEN_KEY } from '../../api/client';

const HUMAN_ATTENTION_COUNT_PATH = '/api/console/conversations/human-attention-count';

export function useHumanAttentionOpenCount(agentId?: string | null) {
  const location = useLocation();
  const onConv = location.pathname.startsWith('/app/conversations');
  const pollMs = onConv ? 12_000 : 45_000;

  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem(TENANT_TOKEN_KEY);
    if (!token) return;
    try {
      const qs = agentId ? `?agentId=${encodeURIComponent(agentId)}` : '';
      const data = await apiGet<{ count: number }>(`${HUMAN_ATTENTION_COUNT_PATH}${qs}`, token, {
        showErrorGrowl: false,
      });
      setCount(typeof data.count === 'number' && data.count > 0 ? data.count : 0);
    } catch {
      /* sin token / red: no romper la UI */
    }
  }, [agentId]);

  useEffect(() => {
    void refresh();
    const id = window.setInterval(() => void refresh(), pollMs);
    return () => window.clearInterval(id);
  }, [refresh, pollMs]);

  useEffect(() => {
    const onFocus = () => void refresh();
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, [refresh]);

  return { count, refresh };
}
